module.exports = __webpack_public_path__ + "img/s2.9ce2fb37.png";